module.exports = function getResource(label, vars = []) {
    let resources = {
        privateProfile: 'This profile is private'
    };
    return resources[label];
};
